<template>
  <div class="basic-info">
    <el-form
      label-position="left"
      label-width="6rem"
      :rules="rules"
      :model="createEdition"
      v-if="editionList.length == 0 || (isEdit && operation == 'create')"
    >
      <div class="edit-view">
        <div class="title">
          <div v-if="operation == 'create'">添加新版本</div>
          <div v-else>基本信息</div>
        </div>
        <el-form-item label="版本名称" prop="name">
          <el-input
            v-model="createEdition.displayName"
            placeholder="请输入版本名称"
          ></el-input>
        </el-form-item>
        <div class="create-btn">
          <el-button type="primary" @click="createSubmit" :loading="isLoading">保存</el-button>
          <el-button @click="cancel">取消</el-button>
        </div>
      </div>
    </el-form>
    <el-form
      label-position="left"
      label-width="4rem"
      :rules="rules"
      :model="updateEditionInfo"
      v-else-if="isEdit && operation !== 'create'"
    >
      <div class="edit-view">
        <div class="title">
          <div>基本信息</div>
        </div>
        <el-form-item label="版本名称" prop="name">
          <el-input
            v-model="updateEditionInfo.displayName"
            placeholder="请输入版本名称"
          ></el-input>
        </el-form-item>

        <div class="update-btn">
          <el-button type="primary" @click="editInfo" :loading="isLoading">保存</el-button>
          <el-button @click="cancel">取消</el-button>
        </div>
      </div>
    </el-form>
    <el-form
      label-position="left"
      label-width="6rem"
      :rules="rules"
      :model="editionUpdataInfo"
      v-else
    >
      <div class="info-view">
        <div class="title">
          {{ editionUpdataInfo.displayName }}
          <div class="edit-btn" @click="updateInfo">管理</div>
        </div>
        <el-form-item label="版本名称">{{
          editionUpdataInfo.displayName
        }}</el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
import { deepCopy } from "@/utils/deepCopy";
import {
  getEditions,
  deleteEdition,
  creatEdition,
  updateEdition,
} from "@/http/api/editions";
export default {
  props: {
    operation: { type: String }, //操作类型
    editionInfo: { type: Object }, // 版本数据
  },
  data() {
    return {
      isEdit: false,
      editionUpdataInfo: {},
      updateEditionInfo: {
        displayName: "",
      },
      isLoading:false,
      createEdition: {
        displayName: "",
      },
      editionList: [],
      rules: {
        displayName: [
          { required: true, message: "版本名称不能为空", trigger: "blur" },
        ],
      },
      permissions: this.$store.getters.permissions, //用户权限集合
    };
  },
  watch: {
    operation(newV, oldV) {
      if (newV == "create") {
        this.isEdit = true;
        this.createEdition = {
          displayName: "",
        };
      } else {
        this.isEdit = false;
      }
      //console.log(newV, oldV);
    },
    editionInfo(newVal, oldVal) {
      this.editionUpdataInfo = deepCopy(this.editionInfo);
      this.updateEditionInfo = deepCopy(this.editionInfo);
    },
  },
  mounted() {
    //console.log(this.editionInfo, "zhelishigroupInfo");
    this.getEditionList();
  },
  methods: {
    getEditionList() {
      var query = {
        maxResultCount: 50,
      };
      getEditions(query).then((res) => {
        this.editionList = res.result.items;
      });
    },
    updateInfo() {
      if (this.permissions["RocketSaas.Editions.Update"]) {
        this.isEdit = true;
        this.updateEditionInfo = deepCopy(this.editionInfo);
        //console.log(this.editionInfo, "获取的管理数据");
      } else {
        this.$message.warning({
          message: `您暂无管理版本权限`,
          showClose: true,
        });
      }
    },
    createSubmit() {
      this.isLoading = true
      creatEdition(this.createEdition).then((res) => {
        if(res.code == 10200){
        this.$emit("newEditionInfo", this.createEdition);
        this.$message({
          message: res.message,
          type: "success",
        });
        this.isLoading = false
        this.isEdit = false;
        }
      }).catch(err=>{
        this.isLoading = false
      });
    },
    editInfo() {
      this.isLoading = true
      //console.log(this.editionUpdataInfo, "获取的this.editionUpdataInfo");
      var data = {
        displayName: this.updateEditionInfo.displayName,
      };
      updateEdition(this.updateEditionInfo.id, data).then((res) => {
        if(res.code == 10200){
        this.$emit("newEditionInfo", this.createEdition);
        this.isLoading = false
        this.isEdit = false;
        this.$message({
          message: res.message,
          type: "success",
        });
        }
      }).catch(err=>{
        this.isLoading = false
      });
    },
    cancel() {
      this.isEdit = false;
      this.$emit("newEditionInfo", this.editionInfo);
      this.getEditionList();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/mixin.scss";
.basic-info {
  padding: 20px 15px 10px 18px;
  text-align: left;

  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;

    margin: 20px 0;
    font-size: 14px;
    font-weight: bold;
    line-height: 14px;
    color: #000;

    .edit-btn {
      font-size: 12px;
      font-weight: 400;
      color: $--color-primary;
      cursor: pointer;
    }
  }
  .info-view {
    .el-form-item {
      margin-bottom: 2px;
    }
  }

  .edit-view {
    .el-form-item {
      margin-bottom: 20px;
      width: 425px;

      .name-tip {
        margin-top: 7px;
        font-size: 12px;
        font-weight: 400;
        line-height: 14px;
        color: #888;
      }
      // ::v-deep .el-form-item__content{
      //   @include flex (row,center);
      // }
      .el-select {
        width: 330px;
      }
      .tip-svg {
        position: relative;
        top: -1px;
        margin-left: 5px;
        width: 14px;
        height: 14px;
        color: #9e9e9e;
      }
    }

    .create-btn {
      margin: 12px 0 0 6rem;
    }
    .update-btn {
      margin: 12px 0 0 4rem;
    }
  }
}
// ::v-deep .custom-tooltip {
//   .custom-tip {
//     padding: 5px;
//   }
// }
</style>